import axios from "axios/index"

export function fetchWeatherData(location) {
    console.log(process.env)
    return {
        type: "FETCH_WEATHER",
        payload: axios.get(`https://api.openweathermap.org/data/2.5/find?lat=` + location.latitude + `&lon=` + location.longitude + `&cnt=30&appid=4ebd5e56033493d33b4cbc08144d4721`)
    }
}



// WEBPACK FOOTER //
// ./src/actions/weatherDataAction.js